<template>
  <div class="documents">
    <div class="container">
      <h1 class="title">Documents</h1>
      <!-- <h2 class="subtitle">
        Click any of the following buttons to download the related doc
      </h2>-->
      <!-- <div class="columns is-multiline is-centered">
        <div :key='doc.name' v-for="doc in documents" class="column is-3">
        <a :href="'./../static/documents/' + doc.path" download :class="['is-medium is-outlined button is-dark' ]" basic :key='doc.name'>{{ doc.name }}</a>
        </div>
      </div>-->
             <a :class="{'is-dark is-orange is-medium button': true }" v-show="school === 'stjustins'" href="https://app.kidsoft.com.au/p/ooshzoneStJustins/find-a-place" target="_blank" >ENROL ONLINE</a>
       <a :class="{'is-dark is-orange is-medium button': true }" v-show="school === 'stgregs'" href="https://app.kidsoft.com.au/p/ooshzoneStGreg/find-a-place" target="_blank" >ENROL ONLINE</a>
       <a :class="{'is-dark is-orange is-medium button': true }" v-show="school === 'maryimmaculate'" href="https://app.kidsoft.com.au/p/ooshzonemaryimmaculate/find-a-place" target="_blank" >ENROL ONLINE</a>
      <aside class="menu">
        <p v-show="school === 'stjustins'" class="menu-label">St Justin’s Catholic Primary School</p>
        <ul v-show="school === 'stjustins'" class="menu-list">
          <li>
            <a :href="'../static/documents/' + documents[1].path" target="_blank">Parent Handbook</a>
          </li>
          <li>
            <a :href="'../static/documents/' + documents[2].path" target="_blank">Direct Debit Form</a>
          </li>
        </ul>
        <p v-show="school === 'stgregs'" class="menu-label">St Gregory’s College Junior School</p>
        <ul v-show="school === 'stgregs'" class="menu-list">
          <li>
            <a :href="'../static/documents/' + documents[4].path" target="_blank">Parent Handbook</a>
          </li>
          <li>
            <a :href="'../static/documents/' + documents[5].path" target="_blank">Direct Debit Form</a>
          </li>
        </ul>
        <p v-show="school === 'maryimmaculate'" class="menu-label">Mary Immaculate Catholic Parish</p>
        <ul v-show="school === 'maryimmaculate'" class="menu-list">
          <li>
            <a :href="'../static/documents/' + documents[9].path" target="_blank">Parent Handbook</a>
          </li>
          <li>
            <a :href="'../static/documents/' + documents[10].path" target="_blank">Direct Debit Form</a>
          </li>
        </ul>
        <p class="menu-label">Common Documents</p>
        <ul class="menu-list">
          <li>
            <a :href="'../static/documents/' + documents[6].path" target="_blank">Medication Record</a>
          </li>
          <li>
            <a
              :href="'../static/documents/' + documents[7].path"
              target="_blank"
            >OOSH Zone Philosophy</a>
          </li>
        </ul>
      </aside>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Documents',
  props: ['school'],
  data () {
    return {
      documents: [
        {
          name: `St Justin's Enrolment Form`,
          path: 'StJustins/St Justins Enrolment Form.pdf',
          color: 'is-info'
        },
        {
          name: `St Justin's Handbook`,
          path: 'StJustins/St Justins Handbook.pdf',
          color: 'is-link'
        },
        {
          name: 'Direct Debit Form',
          path: 'DirectDebitForm.pdf',
          color: 'is-success'
        },
        {
          name: `St Gregs's Enrolment Form`,
          path: 'StGregs/St Gregs Enrolment Form.pdf',
          color: 'is-info'
        },
        {
          name: `St Gregs's Handbook`,
          path: 'StGregs/St Gregs Handbook.pdf',
          color: 'is-link'
        },
        {
          name: 'Direct Debit Form',
          path: 'Direct Debit Form.pdf',
          color: 'is-success'
        },
        {
          name: 'Medication Record',
          path: 'Medication Record.pdf',
          color: 'is-warning'
        },
        {
          name: 'OOSH Zone Philosophy',
          path: 'Oosh Zone Philosophy.pdf',
          color: 'is-danger'
        },
        {
          name: 'Mary Immaculate Enrolment Form',
          path: 'MaryImmaculate/Mary Immaculate Enrolment Form.pdf',
          color: 'is-info'
        },
        {
          name: 'Mary Immaculate Handbook',
          path: 'MaryImmaculate/Mary Immaculate Handbook.pdf',
          color: 'is-link'
        },
        {
          name: 'Direct Debit Form',
          path: 'Direct Debit Form.pdf',
          color: 'is-success'
        }
      ]
    }
  }
}
</script>

<style scoped>
.button.is-dark:hover {
  color: #e67e66;
}
a.button {
  color: #e67e22;
  text-align: left;
}
a.button:hover {
  color: #e67d22b6;
}
.half-col {
  display: inline-block;
  width: 40%;
}
.documents {
  padding: 60px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.button {
  margin: 20px;
}
.menu-list {
  margin-bottom: 40px;
}
.menu-list a {
  border: 2px solid transparent;
  border: 2px solid #111;
  /* border-radius: 0; */
  font-weight: 600;
}

.menu-list a:hover {
  background-color: #e67e22;
  /* border: 2px solid #111; */
  transition: background-color 0.4s;
  transition: border 0.4s;
}
</style>



// WEBPACK FOOTER //
// src/components/Documents.vue